document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href="#cookie-preferences"]');
  if (!link) return;

  event.preventDefault();

  if (window.Shopify?.customerPrivacy?.openPreferences) {
    window.Shopify.customerPrivacy.openPreferences();
  } else {
    console.warn('[cookie-preferences] Shopify customerPrivacy API not available — banner may be disabled or not yet loaded.');
  }
});
